<template>
  <el-drawer
    :title="title"
    :visible.sync="drawerVisible"
    direction="rtl"
    :size="size"
    @selection-change="handleSelectionChange"
  >
    <div class="content">
      <div class="buttons">
        <el-button
          v-for="btn in buttonList"
          :key="btn.name"
          :type="btn.type"
          :size="btn.size"
          @click="handleClick(btn.method)"
        >
          {{ btn.name }}
        </el-button>
      </div>
      <el-table
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <template v-for="item in tableColumns">
          <el-table-column
            v-if="item.prop === 'operate'"
            :key="item.prop"
            fixed="right"
            :label="item.label"
            :width="item.width"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-for="btn in item.btnList"
                :key="btn.method"
                @click="handleClick(btn.method, scope.row)"
                :type="btn.type"
                :size="btn.size"
              >
                {{ btn.name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.prop"
            v-bind="item"
            align="center"
          />
        </template>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '50%'
    },
    title: {
      type: String,
      default: ''
    },
    buttonList: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      drawerVisible: false,
      loading: false
    }
  },
  methods: {
    handleClose(done) {
      if (this.loading) {
        return
      }
      this.$confirm('确定要提交表单吗？')
        .then(() => {
          this.loading = true
          this.timer = setTimeout(() => {
            done()
            // 动画关闭需要一定的时间
            setTimeout(() => {
              this.loading = false
            }, 400)
          }, 2000)
        })
        .catch(() => {})
    },
    cancelForm() {
      this.loading = false
      clearTimeout(this.timer)
    },
    handleClick(name, row) {
      // 表格事件
      this.$emit(name, row)
    },
    handleSelectionChange(val) {
      // 选中
      this.$emit('handleSelectionChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 200px);
  padding: 0 10px;
  .buttons {
    text-align: right;
    margin-bottom: 10px;
  }
}
</style>